import { IconProps } from '../Icons.type'

export function NewHomeIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      {...props}
      viewBox="0 0 21 21">
      <g
        fill="currentColor"
        fillRule="evenodd"
        clipPath="url(#clip0_4058_102960)"
        clipRule="evenodd">
        <path d="M10.387 1.072a.833.833 0 011.023 0l7.5 5.833c.203.158.322.401.322.658v9.167a2.5 2.5 0 01-2.5 2.5H5.065a2.5 2.5 0 01-2.5-2.5V7.563c0-.257.12-.5.322-.658l7.5-5.833zM4.232 7.971v8.759a.833.833 0 00.833.833h11.667a.833.833 0 00.833-.833V7.97L10.9 2.787 4.232 7.97z"></path>
        <path d="M7.565 10.062c0-.46.374-.833.834-.833h5c.46 0 .833.373.833.833v8.333a.833.833 0 01-1.667 0v-7.5H9.232v7.5a.833.833 0 01-1.667 0v-8.333z"></path>
      </g>
      <defs>
        <clipPath id="clip0_4058_102960">
          <path
            fill="currentColor"
            d="M0 0H20V20H0z"
            transform="translate(.898 .063)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}
